import HousesNearByHeatMap from "./HousesNearbyHeatMap";

export default HousesNearByHeatMap;
